<template>
  <Grid gtc="200px 1fr" class="overflow-hidden relative-position">
    <template v-if="quickViewItems">
      <ModalSidebar ref="modalSidebar" :items="quickViewItems" @item-selected="openQuickView" />

      <Grid gtr="1fr auto" class="overflow-hidden">
        <ModalBody>
          <div v-if="quickView" :key="quickView.id" class="q-pa-lg bg-white-1 shadow3 border-radius-sm">
            <div class="text-heading-1 text-subtitle2 q-mb-lg">{{ quickView.name }}</div>

            <Evaluations :evaluation="quickView" />
          </div>
        </ModalBody>

        <ModalFooter>
          <RBtn size="big" type="ghost" @click="dismiss">Dismiss</RBtn>
          <RBtn size="big" type="primary" @click="save">Save</RBtn>
          <RBtn size="big" type="tertiary" @click="finalize">Finalize</RBtn>
        </ModalFooter>
      </Grid>
    </template>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { getCount, setSubtitle, checkQuickView, openQuickView, getTaskData } from '../modals-shared'
// Components
import Evaluations from '@/reusable/evaluation-form/Evaluations'
import ModalSidebar from '../components/ModalSidebar'
import ModalBody from '../components/ModalBody'
import ModalFooter from '../components/ModalFooter'

export default {
  components: {
    Evaluations,
    ModalSidebar,
    ModalBody,
    ModalFooter
  },

  props: {
    periodId: [Number, String]
  },

  data() {
    return {
      quickViewItems: null,
      quickView: null
    }
  },

  watch: {
    quickViewItems: 'setSubtitle'
  },

  created() {
    this.getTaskData('evaluations').then(({ data }) => (this.quickViewItems = data.result))
  },

  methods: {
    getTaskData,
    getCount,
    checkQuickView,
    setSubtitle: setSubtitle('Subscriptions'),
    openQuickView: openQuickView('evaluations'),

    getPayload(finalize) {
      return {
        content: this.quickView.custom_form?.content || null,
        form_id: this.quickView.custom_form?.form_id || null,
        finalized: finalize,
        note: this.quickView.general_form.note.value,
        price_satisfaction: this.quickView.general_form.price_satisfaction.value,
        usage_satisfaction: this.quickView.general_form.usage_satisfaction.value,
        content_satisfaction: this.quickView.general_form.content_satisfaction.value,
        recommendation: this.quickView.general_form.recommendation.value
      }
    },

    dismiss() {
      this.$emit('set-loader', true)

      apiTo
        .DISMISS_TASK('evaluations', this.quickView.id)
        .then(this.checkQuickView)
        .catch(() => this.$emit('set-loader', false))
    },

    save() {
      const payload = this.getPayload(false)

      this.$emit('set-loader', true)
      apiTo.PROCESS_TASK('evaluations', this.quickView.id, payload).finally(() => this.$emit('set-loader', false))
    },

    finalize() {
      const payload = this.getPayload(true)

      this.$emit('set-loader', true)
      apiTo
        .PROCESS_TASK('evaluations', this.quickView.id, payload)
        .then(this.checkQuickView)
        .finally(() => this.$emit('set-loader', false))
    }
  }
}
</script>
